// @ts-nocheck
import styled from 'styled-components';

export const ReportingCommentSectionStyle = styled.div`
  .commentSection {
    &__box {
      margin-top: 8px;
      height: unset !important;
      box-shadow: 0 0 26px 5px rgba(18, 22, 30, 0.06);
    }

    &__commentTextArea {
      height: 140px;
      border-radius: 4px;
      resize: none;
    }

    &__saveComment {
      background-color: #E9EFFF;
      font-family: ${props => props.theme.fontSemiBold};
      white-space: pre-wrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &__cancelButton {
      padding: 8px 0;
    }

    &__buttonsArea {
      margin-top: 16px;
      display: flex;
      justify-content: space-between;

      &LeftSide {
        justify-content: flex-start;
      }

      &RightSide {
        display: flex;
        justify-content: flex-end;
        gap: 8px;
      }
    }
  }
`;
